import React, { useEffect, useRef } from "react";
import EventoVisualizarController from "../../DefaultPage/Evento/controller/evento-visualizar.controller";
import If from "../../../../vendors/components/If";
import EventoCard from "../../../components/evento-card";
import AnexoCard from "../../../components/anexo/AnexoCard";
import { Card } from "primereact/card";
import EventoVisualizarHeader from "../../DefaultPage/Evento/components/EventoVisualizarHeader";
import Tabs from "../../../components/tabs";
import Contribuir from "../../DefaultPage/Evento/components/Contribuir";
import NormaDefinitiva from "../../DefaultPage/Evento/components/NormaDefinitiva";
import Degravacao from "../../DefaultPage/Evento/components/Degravacao";
import ContribuicaoPublicada from "../../DefaultPage/Evento/components/ContribuicaoPublicada";
import ModalLogin from "../../../components/modal-login";
import SessaoPresencial from "../../DefaultPage/Evento/components/SessaoPresencial";
import { useLocation } from "react-router-dom";
import DocumentosdoEvento from "../../DefaultPage/Evento/components/DocumentosdoEvento";
import Topbar from "../../../../vendors/components/Layouts/Default/Topbar";
import EventoInformesPopup from "../../../components/evento-informes-popup";
import {
  isEventoInterno,
  hasSessaoEventoInterno,
  ativarLayoutEventoInterno,
} from "../../../shared/utils/EventoInternoUtil";

export default function EventoInterno() {
  const controller = new EventoVisualizarController(true);
  const evento = controller.evento;

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    ativarLayoutEventoInterno();
    controller.initEventoInterno();
  }, []);

  const codPropostaNorma = evento.codPropostaNorma
  console.log(controller.lista)

  return (
    <div>
      <EventoInformesPopup evento={evento} />
      <div className="evento-vis-wrapper">
        <If condition={controller.show}>
          <div className="evento-vis-col-secundaria">
            <EventoCard
              evento={evento}
              onHide={() => controller.handleShow()}
            />
            <AnexoCard
              showDownload={true}
              handleDownload={(e: any) => {
                controller.downloadPropostaNorma(e);
              }}
              handleAllDownload={() => {
                controller.downloadTodosAnexos();
              }}
              lista={controller.lista}
              handleTabDocumentacao={(value: any) => {
                controller.handleTab(value);
                handleScrollToTop();
              }}
            />
          </div>
        </If>
        <div
          className="evento-vis-col-primaria"
          style={{ width: controller.show ? "" : "100%" }}
        >
          <Card
            className="card-no-spaces"
            header={() => (
              <EventoVisualizarHeader controller={controller} evento={evento} />
            )}
          >
            <Tabs
              onClick={(value: any) => controller.handleTab(value)}
              ativo={controller.tab}
              items={controller.abaList}
            />

            <Contribuir
              controller={controller}
              isBlock={!hasSessaoEventoInterno()}
            />
            <SessaoPresencial controller={controller} />
            <NormaDefinitiva controller={controller} />
            <Degravacao controller={controller} />
            <ContribuicaoPublicada
              rollBackUrl={`/evento-interno?tab=${controller.tab}`}
              controller={controller}
            />
            {codPropostaNorma && (
              <DocumentosdoEvento
                controller={controller}
                codPropostaNorma={codPropostaNorma}
              />
            )}
          </Card>
        </div>
      </div>
      <ModalLogin
        visible={controller.visibleLogin}
        onHide={() => controller.setVisibleLogin(false)}
        dispositivoLogin={controller.dispositivoLogin}
        isEventoInterno={isEventoInterno(evento)}
        onLoginSuccess={(d) => controller.navegarAposLoginInterno(d)}
      />
    </div>
  );
}
